(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory7LangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory7Languages: function (parms) {
                return $ihttp.post({
                    method: 2698,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2699,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
